import { makeStyles } from '@material-ui/core';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';

// How long the bind confetti stays mounted; it fades out over the last CONFETTI_FADE_MS so the pieces
// don't vanish mid-air.
export const CONFETTI_DURATION_MS = 2500;
const CONFETTI_FADE_MS = 300;

const styles = (theme) => ({
  '@keyframes confettiFadeOut': {
    to: { opacity: 0 }
  },
  // Confetti layer under the page header and behind the spin wheel card (zIndex 1); clicks pass through
  confetti: {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    animation: `$confettiFadeOut ${CONFETTI_FADE_MS}ms var(--motion-ease-out) ${CONFETTI_DURATION_MS - CONFETTI_FADE_MS}ms forwards`
  },
  // Screen-reader-only text
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
  },
  spinner: {
    width: 96,
    height: 96,
    marginTop: 60,
    marginBottom: 20
  },
  container: {
    width: 600,
    margin: '0 auto'
  },
  button: {
    width: 288,
    marginBottom: 16
  },
  subtitle: {
    marginTop: 32,
    marginBottom: 50,
    textAlign: 'center'
  },
  spinWheelCard: {
    width: '100%',
    maxWidth: 600,
    marginTop: -30,
    marginBottom: 20,
    padding: 0,
    position: 'relative',
    zIndex: 1
  },
  spinResultCard: {
    minHeight: 500,
    padding: '40px 24px',
    backgroundColor: theme.colorPalette.beige_40
  },
  spinResultImage: {
    width: 200,
    marginBottom: 32
  },
  spinResultSubtitle: {
    marginTop: 16,
    textAlign: 'center',
    display: 'block'
  },
  spinResultHelpText: {
    marginTop: 24,
    fontSize: 12,
    textAlign: 'center'
  },
  spinResultLink: {
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colorPalette.orange_75 : '#c27c2c',
    marginTop: 20,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  spinResultLinkIcon: {
    fontSize: 16
  },
  spinLoadingSpinner: {
    width: 96,
    height: 96
  },
  openInNewIcon: {
    fontSize: 18,
    marginRight: 8
  }
});

export default makeStyles(styles);
